import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

function NavItem({ to, label, desc }) {
    return (
        <NavLink
            to={to}
            className={({ isActive }) =>
                [
                    "block rounded-2xl border px-4 py-3.5 transition",
                    isActive
                        ? "border-accent-500/35 bg-gradient-to-b from-accent-500/16 to-bg-850/10 shadow-glow"
                        : "border-line-800/70 bg-bg-850/18 hover:bg-bg-850/30"
                ].join(" ")
            }
            end
        >
            <div className="text-text-100 font-semibold leading-tight">{label}</div>
            <div className="text-text-300 text-sm mt-1 leading-snug">{desc}</div>
        </NavLink>
    );
}

export default function AppShell() {
    const { user, role, logout } = useAuth();

    return (
        <div className="min-h-screen">
            <div className="max-w-7xl mx-auto px-4 py-7">
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 mb-6">
                    <div>
                        <div className="text-text-100 font-extrabold text-3xl tracking-tight">RC Checker</div>
                        <div className="text-text-300 mt-2">Ověření pouze ano nebo ne</div>
                    </div>

                    <div className="flex items-center gap-3">
                        <div className="chip border-line-800/70 bg-bg-850/18 text-text-300">
                            <span className="h-2 w-2 rounded-full bg-ok" />
                            {user ? user.username : "Neznámý"}
                        </div>

                        <button onClick={logout} className="btnGhost">
                            Odhlásit
                        </button>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-[320px_1fr] gap-6">
                    <aside className="card overflow-hidden">
                        <div className="cardHeader">
                            <div className="text-text-100 font-bold text-xl leading-tight">Menu</div>
                            <div className="text-text-300 text-sm mt-1">Role: {role === 2 ? "Superadmin" : role === 1 ? "Admin" : "User"}</div>
                        </div>

                        <div className="cardBody space-y-3">
                            <NavItem to="/" label="Ověření" desc="Zadat jméno a RČ a zjistit registraci" />
                            <NavItem to="/register" label="Registrace" desc="Zapsat nový doklad do registru" />

                            {role >= 1 ? <NavItem to="/admin" label="Administrace" desc="Vytváření uživatelů a přístupy" /> : null}
                            {role >= 2 ? <NavItem to="/superadmin" label="Superadmin" desc="Nastavení rolí adminů" /> : null}

                            <div className="mt-2 rounded-2xl border border-line-800/70 bg-bg-850/16 p-4">
                                <div className="label">Bezpečnost</div>
                                <div className="text-text-300 text-sm mt-2 leading-relaxed">
                                    Do DB se ukládají jen HMAC otisky, ne čitelné údaje.
                                </div>
                            </div>
                        </div>
                    </aside>

                    <main className="space-y-6">
                        <Outlet />
                    </main>
                </div>
            </div>
        </div>
    );
}
